module.exports = __webpack_public_path__ + "img/dashboard-sidebar-desktop-fr.b784cb03.jpg";